import CeisaMasterCustomerIndex from "@/components/exim/ceisa/master_customer/CeisaMasterCustomerIndex.vue";
import CeisaMasterCustomerUpload from "@/components/exim/ceisa/master_customer/CeisaMasterCustomerUpload.vue";
import CeisaMasterCustomerCreate from "@/components/exim/ceisa/master_customer/CeisaMasterCustomerCreate.vue";
import CeisaMasterCustomerDetail from "@/components/exim/ceisa/master_customer/CeisaMasterCustomerDetail.vue";
import CeisaMasterCustomerUpdate from "@/components/exim/ceisa/master_customer/CeisaMasterCustomerUpdate.vue";

let routesAsn= [
    {
        path: '',
        meta: {
            title: "Ceisa Master Customer",
        },
        name: "CeisaMasterCustomerIndex",
        component: CeisaMasterCustomerIndex
    },
    {
        path: 'create',
        meta: {
          title: "Ceisa Master Customer Create",
        },
        name: "CeisaMasterCustomerCreate",
        component: CeisaMasterCustomerCreate
    },

    {
        path: 'upload',
        meta: {
          title: "Ceisa Master Customer",
        },
        name: "CeisaMasterCustomerUpload",
        component: CeisaMasterCustomerUpload
    },

    {
        path: 'detail/:id',
        meta: {
          title: "Ceisa Master Customer Detail",
        },
        name: "CeisaMasterCustomerDetail",
        component: CeisaMasterCustomerDetail
    },


    {
      path: 'edit/:id',
      meta: {
        title: "Ceisa Master Customer Update",
      },
      name: "CeisaMasterCustomerUpdate",
      component: CeisaMasterCustomerUpdate
  },
     
    
]

export default routesAsn
  